import React from "react";

const ProductSkeletonCard: React.FC = () => {
  return (
    // Replaced AntD Card/Skeleton structure with simple divs and Tailwind classes
    <div className="border border-gray-300 rounded-lg overflow-hidden flex flex-col h-full shadow-sm animate-pulse">
      
      {/* image-wrapper: Use a gray background div */}
      <div className="relative w-full aspect-square bg-gray-300">
        {/* The background color is enough for the placeholder */}
      </div>

      {/* product-details */}
      <div className="p-3 flex flex-col flex-grow">
        <div>
          {/* product-title: Use a gray bar */}
          <div className="mb-2 h-4 bg-gray-300 rounded w-4/5"></div>
        </div>
        
        {/* price-container */}
        <div className="flex justify-between items-center mb-2 text-xs">
          {/* saling-price */}
          <div className="flex items-center gap-1">
            <div className="h-4 bg-gray-300 rounded w-12"></div>
            <div className="h-4 bg-gray-300 rounded w-20"></div>
          </div>
          {/* stat-item */}
          <div className="flex items-center">
             <div className="h-4 bg-gray-300 rounded w-24"></div>
          </div>
        </div>
        
        {/* sold-units */}
        <div className="mb-2 h-4 bg-gray-300 rounded w-3/5"></div>
        
        {/* stats-container */}
        <div className="flex justify-between mb-4 text-xs text-center">
          <div className="flex flex-col items-center gap-1">
            <div className="h-4 bg-gray-300 rounded w-16"></div>
            <div className="h-4 bg-gray-300 rounded w-16"></div>
          </div>
          <div className="flex flex-col items-center gap-1">
            <div className="h-4 bg-gray-300 rounded w-16"></div>
            <div className="h-4 bg-gray-300 rounded w-16"></div>
          </div>
          <div className="flex flex-col items-center gap-1">
             <div className="h-4 bg-gray-300 rounded w-16"></div>
             <div className="h-4 bg-gray-300 rounded w-16"></div>
          </div>
        </div>

        {/* product-quick-view-wrap */}
        <div className="mt-auto">
          {/* action-btns */}
          <div className="flex gap-2">
            <div className="h-8 bg-gray-300 rounded w-full"></div>
            <div className="h-8 bg-gray-300 rounded w-full"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSkeletonCard;
